<template>
  <div class="">
    <div class="mt-2" :style="{'margin-right':`${margin}px`}">
      <label @click="checkboxClicked(category)" class="mr-1" :for="`category_${category.id}`">{{
          category.name
        }}</label>
    </div>

    <category :remove-category="removeCategory"
              :selected-category="selectedCategory"
              v-for="children in category.children" :margin="margin+30"
              :key="children.id"
              :category="children"/>

  </div>
</template>

<script>
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "category",
  props: ['category', 'margin', 'selectedCategory', 'removeCategory'],
  methods: {
    checkboxClicked(category) {
      let ids = this.selectedCategory.map(item => item.id)
      if (ids.indexOf(category.id) === -1) {
        this.selectedCategory.push(category)
        toast('ایتم اضافه شد', 'ایتم اضافه شد')
      } else {
        toast('ایتم وجود دارد', 'ایتم وجود دارد', 'danger')
      }
    }
  }

}
</script>

<style scoped>

</style>